import "./Footer.scss";

import classNames from "classnames";
import { useLayout, useTranslations } from "providers";

import { FooterLinks } from "./FooterLinks";
import { getHelpLinks } from "./getHelpLinks";
import { getProductLinks } from "./getProductLinks";
import { getSupportLinks } from "./getSupportLinks";
import { getHeadingHelp, getHeadingImprint, getHeadingSupport } from "./translations";

export const Footer: React.FC = () => {
  const { isFooterVisible, setIsFooterVisible } = useLayout();
  const footerContent = document.getElementById("sbb-footer-content");
  const i18n = useTranslations();

  const helpLinks = getHelpLinks();
  const productLinks = getProductLinks();
  const supportLinks = getSupportLinks();

  return (
    <footer className="sbb-footer">
      <div
        className={classNames("sbb-footer-toggler d-flex d-flex-row", isFooterVisible ? "expanded" : "")}
        aria-expanded={isFooterVisible ? "true" : "false"}
        onClick={() => {
          const newState = !isFooterVisible;
          setIsFooterVisible(newState);
          if (newState) {
            footerContent?.scrollIntoView();
          }
        }}
      >
        <span className="u-sr-only">{i18n.Footer_Title}</span>
        <button className="btn btn-link">
          <svg
            focusable="false"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            className="icon"
            viewBox="0 0 24 24"
          >
            <polyline fill="none" stroke="currentColor" points="15.9 13.675 11.996 9.725 8.092 13.674" />
          </svg>
          <p>{i18n.Footer_Title}</p>
        </button>
      </div>

      {isFooterVisible && (
        <div className="footer-content" id="sbb-footer-content">
          <div>
            <div className="container-fluid">
              <div className="row">
                <div className="col col-md-3">
                  <FooterLinks prefix="product" items={productLinks} heading={getHeadingImprint()} />
                </div>
                <div className="col col-md-3">
                  <FooterLinks prefix="help" items={helpLinks} heading={getHeadingHelp()} />
                </div>
                <div className="col col-md-3">
                  <FooterLinks prefix="support" items={supportLinks} heading={getHeadingSupport()} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
};
